module.exports = __webpack_public_path__ + "img/qrcode-infoq.5f9d2fd2.png";